export const environment = {
    production: true,
    apiBase: 'https://datarequest.mrcmekong.org/api/v1/',
    cmsBase: 'https://datarequest.mrcmekong.org/',
    // indicatorFrameworkApiBase: 'https://datarequest.mrcmekong.org/sedbapi/v1/',
    indicatorFrameworkApiBase: 'https://sedb.portal.mrcmekong.org/sedbapi/v1/',
    fisheryApiBase: 'http://localhost:8080/fisheryapi/v1/',
    tsBase: 'https://timeseries.api.mrcmekong.org/api/v1/',
    mrcApiBase : 'https://api.mrcmekong.org/api/v1',
    mapboxAccessToken: 'pk.eyJ1Ijoia2l0dGlwaG9uZyIsImEiOiJjbG82a2p0OG0wN2xsMnRwMDV3M2J4eG9sIn0.IzPgD2UyXDzvLmTBt2v2Vg',
    mrcChartKey: '56b6f095-2243-4d73-9bcf-57600ef1f38b',
    bcelPaymentUrl: 'https://secureacceptance.cybersource.com/oneclick/pay',
    geoserverUrl: 'https://geo.mrcmekong.org/geo',
    pnpcaGeoJson: 'https://geo.mrcmekong.org/geo/mrc/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=mrc%3APNPCA_2019_Updated&maxFeatures=1000&outputFormat=application%2Fjson'
};
